// Author thq
// Date 2024-06-06 22:55:59

class EmSparePartsInventorySpi {
    constructor({
                    id = null,
                    spiIdSpa = '',
                    spiCodeSpa = '',
                    spiNameSpa = '',
                    spiModel = '',
                    spiUsedDevice = '',
                    spiUsedDeviceName = '',
                    spiUsedDept = '',
                    spiUsedDeptName = '',
                    spiStorageType = '',
                    spiQuantity = '',
                    spiUnit = '',
                    spiPrice = '',
                    spiWarehouseId = '',
                    spiLocationId = '',
                    spiLocationName = '',
                    spiStorageStartTime = '',
                    remark = '',
                    attachment = '',
                    attachmentList = ''
                }
                    = {}) {
        this.id = id;
        this.spiIdSpa = spiIdSpa;
        this.spiCodeSpa = spiCodeSpa;
        this.spiNameSpa = spiNameSpa;
        this.spiModel = spiModel;
        this.spiUsedDevice = spiUsedDevice;
        this.spiUsedDeviceName = spiUsedDeviceName;
        this.spiUsedDept = spiUsedDept;
        this.spiUsedDeptName = spiUsedDeptName;
        this.spiStorageType = spiStorageType;
        this.spiQuantity = spiQuantity;
        this.spiUnit = spiUnit;
        this.spiPrice = spiPrice;
        this.spiWarehouseId = spiWarehouseId;
        this.spiLocationId = spiLocationId;
        this.spiLocationName = spiLocationName;
        this.spiStorageStartTime = spiStorageStartTime;
        this.remark = remark;
        this.attachment = attachment;
        this.attachmentList = attachmentList;
    }
}

function newEntity() {
    return new EmSparePartsInventorySpi();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.spareparts.emSparePartsInventorySpi.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'spiCodeSpa',
            label: 'label.em.spareparts.emSparePartsInventorySpi.grid.spiCodeSpa',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'spiNameSpa',
            label: 'label.em.spareparts.emSparePartsInventorySpi.grid.spiNameSpa',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'spiModel',
            label: 'label.em.spareparts.emSparePartsInventorySpi.grid.spiModel',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'SpiUsedDevice',
            label: 'label.em.spareparts.emSparePartsInventorySpi.grid.SpiUsedDevice',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'spiUsedDeviceCode',
            label: 'label.em.spareparts.emSparePartsInventorySpi.grid.spiUsedDeviceCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'spiUsedDeviceName',
            label: 'label.em.spareparts.emSparePartsInventorySpi.grid.spiUsedDeviceName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'SpiUsedDept',
            label: 'label.em.spareparts.emSparePartsInventorySpi.grid.SpiUsedDept',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'spiUsedDeptName',
            label: 'label.em.spareparts.emSparePartsInventorySpi.grid.spiUsedDeptName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'spiStorageType',
            label: 'label.em.spareparts.emSparePartsInventorySpi.grid.spiStorageType',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'spiStorageTypeName',
            label: 'label.em.spareparts.emSparePartsInventorySpi.grid.spiStorageTypeName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'spiQuantity',
            label: 'label.em.spareparts.emSparePartsInventorySpi.grid.spiQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'spiUnit',
            label: 'label.em.spareparts.emSparePartsInventorySpi.grid.spiUnit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'spiPrice',
            label: 'label.em.spareparts.emSparePartsInventorySpi.grid.spiPrice',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'spiWarehouseId',
            label: 'label.em.spareparts.emSparePartsInventorySpi.grid.spiWarehouseId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'spiWarehouseName',
            label: 'label.em.spareparts.emSparePartsInventorySpi.grid.spiWarehouseName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'spiLocationId',
            label: 'label.em.spareparts.emSparePartsInventorySpi.grid.spiLocationId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'spiLocationName',
            label: 'label.em.spareparts.emSparePartsInventorySpi.grid.spiLocationName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'spiKeeper',
            label: 'label.em.spareparts.emSparePartsInventorySpi.grid.spiKeeper',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'spiStorageStartTime',
            label: 'label.em.spareparts.emSparePartsInventorySpi.grid.spiStorageStartTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.em.spareparts.emSparePartsInventorySpi.grid.remark',
            sortable: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'attachmentList',
            label: 'label.em.spareparts.emSparePartsInventorySpi.grid.attachmentList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    spiIdSpaFilter: '',
    spiCodeSpaFilter: '',
    spiNameSpaFilter: '',
    spiModelFilter: '',
    spiStorageTypeFilter: '',
    spiWarehouseIdFilter: '',
    spiLocationIdFilter: '',
    spiLocationNameFilter: '',
    spiUsedDeviceFilter: '',
    spiUsedDeviceNameFilter: '',
    spiUsedDeptFilter: '',
    spiUsedDeptNameFilter: '',
    spiQuantityFilter: '',
    spiUnitFilter: '',
    spiStorageStartTimeRteFilter: '',
    spiStorageStartTimeLteFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'spiCodeSpaFilter',
        label: 'label.em.spareparts.emSparePartsInventorySpi.filter.spiCodeSpa',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'spiNameSpaFilter',
        label: 'label.em.spareparts.emSparePartsInventorySpi.filter.spiNameSpa',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'spiModelFilter',
        label: 'label.em.spareparts.emSparePartsInventorySpi.filter.spiModel',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'spiStorageTypeFilter',
        label: 'label.em.spareparts.emSparePartsInventorySpi.filter.spiStorageType',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'emSppAttribute'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'spiWarehouseIdFilter',
        label: 'label.em.spareparts.emSparePartsInventorySpi.filter.spiWarehouseId',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'emSppLocation'
            , showLabelSelectOne: true
            , fieldsBindingByEntityModalSelected: '{"spiWarehouseId":"id"}'
            , selectFilter: {processBusinessEntityFilter: 'EmSppLocation', typeFilter: 1}
        }
    },
    {
        key: 'spiLocationNameFilter',
        label: 'label.em.spareparts.emSparePartsInventorySpi.filter.spiLocationName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emSppLocation'
            , correspondingField: 'id'
            , fieldsBindingByEntityModalSelected: '{"spiWarehouseId":"id"}'
        }
    },
    {
        key: 'spiUsedDeviceFilter',
        label: 'label.em.spareparts.emSparePartsInventorySpi.filter.spiUsedDevice',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'spiUsedDeviceNameFilter',
        label: 'label.em.spareparts.emSparePartsInventorySpi.filter.spiUsedDeviceName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emArchBasicData'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"spiUsedDevice":"id"}'
        }
    },
    {
        key: 'spiUsedDeptNameFilter',
        label: 'label.em.spareparts.emSparePartsInventorySpi.filter.spiUsedDeptName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclDept'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"spiUsedDept":"id"}'
        }
    },
    {
        key: 'spiStorageStartTimeRteFilter',
        label: 'label.em.spareparts.emSparePartsInventorySpi.filter.spiStorageStartTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'spiStorageStartTimeLteFilter',
        label: 'label.em.spareparts.emSparePartsInventorySpi.filter.spiStorageStartTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'spiCodeSpa',
        label: 'label.em.spareparts.emSparePartsInventorySpi.entity.spiCodeSpa',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'spiNameSpa',
        label: 'label.em.spareparts.emSparePartsInventorySpi.entity.spiNameSpa',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
            , required: true
        }
    },
    {
        key: 'spiModel',
        label: 'label.em.spareparts.emSparePartsInventorySpi.entity.spiModel',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'spiUsedDeviceName',
        label: 'label.em.spareparts.emSparePartsInventorySpi.entity.spiUsedDeviceName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emArchBasicData'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"spiUsedDevice":"id"}'
        }
    },
    {
        key: 'spiUsedDeptName',
        label: 'label.em.spareparts.emSparePartsInventorySpi.entity.spiUsedDeptName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclDept'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"spiUsedDept":"id"}'
        }
    },
    {
        key: 'spiStorageType',
        label: 'label.em.spareparts.emSparePartsInventorySpi.entity.spiStorageType',
        sortable: true,
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'emSppAttribute'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'spiQuantity',
        label: 'label.em.spareparts.emSparePartsInventorySpi.entity.spiQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'spiUnit',
        label: 'label.em.spareparts.emSparePartsInventorySpi.entity.spiUnit',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'spiPrice',
        label: 'label.em.spareparts.emSparePartsInventorySpi.entity.spiPrice',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'spiWarehouseId',
        label: 'label.em.spareparts.emSparePartsInventorySpi.entity.spiWarehouseId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'emSppLocation'
            , showLabelSelectOne: true
            , fieldsBindingByEntityModalSelected: '{"spiWarehouseId":"id"}'
            , selectFilter: {processBusinessEntityFilter: 'EmSppLocation', typeFilter: 1}
        }
    },
    {
        key: 'spiLocationName',
        label: 'label.em.spareparts.emSparePartsInventorySpi.entity.spiLocationName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emSppLocation'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"spiLocationId":"id"}'
        }
    },
    {
        key: 'spiStorageStartTime',
        label: 'label.em.spareparts.emSparePartsInventorySpi.entity.spiStorageStartTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.em.spareparts.emSparePartsInventorySpi.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachmentList',
        label: 'label.em.spareparts.emSparePartsInventorySpi.entity.attachment',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'attachment'
        }
    }
]

export {
    EmSparePartsInventorySpi, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
